

























import { trackEvent } from '@tt4b/ttam-utils';
import { computed, defineComponent, ref } from '@vue/composition-api';

const name = 'ttam-auto-save-exit-button';
export default defineComponent({
  name,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isShowDropDown: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isDropOpen = ref(false);
    const arrowIcon = computed(() => (isDropOpen.value ? 'vi-icon2-arrowup' : 'vi-icon2-arrowdown'));
    const onClick = () => {
      emit('click');
    };
    const onClickArrowIcon = () => {
      isDropOpen.value = !isDropOpen.value;
      if (isDropOpen.value) {
        trackEvent('ttam_creation_draft_discard_and_exit_dropdown');
      }
    };
    const onClickDiscard = () => {
      trackEvent('ttam_creation_draft_discard_and_exit_button');
      emit('discard');
    };
    const onDropDownVisibleChange = val => {
      isDropOpen.value = val;
    };
    return {
      name,
      arrowIcon,
      isDropOpen,
      onClick,
      onClickArrowIcon,
      onClickDiscard,
      onDropDownVisibleChange,
    };
  },
});
